import React from 'react';
import { FaFileLines, FaBolt, FaDownload, FaLock, FaPenRuler, FaClock } from 'react-icons/fa6';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

// Icon mapping
const iconComponents = {
  FaFileLines: FaFileLines,
  FaBolt: FaBolt,
  FaDownload: FaDownload,
  FaLock: FaLock,
  FaPenRuler: FaPenRuler,
  FaClock: FaClock,
  MdAttachMoney: () => <span>💰</span>,
  MdPayment: () => <span>💳</span>,
  FaCalendarAlt: () => <span>📅</span>,
  FaFileInvoice: () => <span>📄</span>,
  FaUserTie: () => <span>👔</span>,
  FaChartLine: () => <span>📈</span>,
  FaShieldAlt: () => <span>🛡️</span>,
  FaHeart: () => <span>❤️</span>,
  FaGem: () => <span>💎</span>,
};

export const getIconComponent = (iconName) => {
  return iconComponents[iconName] || (() => <span>📋</span>);
};

const FeaturesSection = () => {
  const { data: homePage, isLoading, error } = usePageData('homePage');

  if (isLoading) {
    return (
      <section className="features">
        <div className="container">
          <LoadingSkeleton type="text" count={2} />
          <div className="divider"></div>
          <div className="feature-grid">
            {[...Array(6)].map((_, i) => (
              <div className="feature-card" key={i}>
                <LoadingSkeleton type="card" count={1} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error || !homePage || !homePage.features) {
    return (
      <section className="features">
        <div className="container">
          <h2 className="section-title">Everything You Need, Nothing You Don't</h2>
          <p className="section-subtitle">
            Simple, powerful tools to create professional documents that get you noticed.
          </p>
          <div className="divider"></div>

          <div className="feature-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div className="feature-card" key={i}>
                <div className="feature-icon">📋</div>
                <h3>Feature {i}</h3>
                <p>Description for feature {i}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">{homePage.features_title}</h2>
        <p className="section-subtitle">{homePage.features_subtitle}</p>
        <div className="divider"></div>

        <div className="feature-grid">
          {homePage.features.map((feature, index) => {
            const IconComponent = getIconComponent(feature.icon);
            return (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <IconComponent />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;